import { orgInfoSchema } from '@symon-ai/wisepipe-authorize-domain';
export const idpInfoSchema = {
    $id: 'urn:wisepipe-common-auth:IdpInfoSchema',
    type: 'object',
    properties: {
        id: { type: 'string', minLength: 1, format: 'uuid' },
        domainName: { type: 'string', minLength: 1 },
        idpName: { type: 'string', minLength: 1 },
        displayName: { type: 'string', minLength: 1 },
        connectedOrgs: { type: 'array', items: { $ref: orgInfoSchema.$id } }
    }
};
//# sourceMappingURL=idpInfo.js.map